<template>
    <path
        d="M2.74837 21.8688H22.3491V2.26801C22.3491 1.26565 23.1616 0.453125 24.164 0.453125C25.1664 0.453125 25.9789 1.26565 25.9789 2.26801V21.8688H45.5796C46.582 21.8688 47.3945 22.6813 47.3945 23.6836C47.3945 24.686 46.582 25.4985 45.5796 25.4985H25.9789V45.0993C25.9789 46.1016 25.1664 46.9142 24.164 46.9142C23.1616 46.9142 22.3491 46.1016 22.3491 45.0993V25.4985H2.74837C1.74601 25.4985 0.933491 24.686 0.933491 23.6836C0.933491 22.6813 1.74601 21.8688 2.74837 21.8688Z"
        fill="#FAFCFF"
    />
</template>
